import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { GestureController, ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

@Component({
    selector: 'app-preview-file',
    templateUrl: './preview-file.component.html',
    styleUrls: ['./preview-file.component.scss'],
})
export class PreviewFileModalComponent implements OnInit, AfterViewInit {

    @ViewChild('imageWrapper', { read: ElementRef }) imageWrapper!: ElementRef;

    public FileUrl: string;

    // gallery mode: several files (param `urls`) with navigation, `index` = starting file
    public HeaderTitle: string = '';
    public Urls: string[] = [];
    public Index: number = 0;

    zoom: number = 1;
    rotation: number = 0;

    isDragging: boolean = false;
    dragStartX: number = 0;
    dragStartY: number = 0;
    translateX: number = 0;
    translateY: number = 0;


    public FileFormat: 'pdf' | 'image' | 'unknown' = 'pdf';

    constructor(
        private ModalController: ModalController,
        private NavParams: NavParams
    ) {


        this.HeaderTitle = this.NavParams.get('headerTitle') || '';
        this.Urls = this.NavParams.get('urls') || [];

        this.Index = Math.min(Math.max(Number(this.NavParams.get('index')) || 0, 0), Math.max(this.Urls.length - 1, 0));

        this.FileUrl = this.Urls.length > 0 ? this.Urls[this.Index] : (this.NavParams.get('url') || '');

        this.FileFormat = this.getFileType(this.FileUrl);
    }

    ngOnInit() { }
    ngAfterViewInit() { }

    public get HasGallery(): boolean {

        return this.Urls.length > 1;
    }

    public OnPrevious() {

        if (this.Index > 0) this.OnSelect(this.Index - 1);
    }

    public OnNext() {

        if (this.Index < this.Urls.length - 1) this.OnSelect(this.Index + 1);
    }

    public OnSelect(index: number) {

        this.Index = index;
        this.FileUrl = this.Urls[index];
        this.FileFormat = this.getFileType(this.FileUrl);

        this.Reset();
    }

    @HostListener('document:keydown', ['$event'])
    OnKeydown(ev: KeyboardEvent) {

        if (!this.HasGallery) return;

        if (ev.key == 'ArrowLeft') this.OnPrevious();
        else if (ev.key == 'ArrowRight') this.OnNext();
    }

    Reset() {

        this.zoom = 1;
        this.rotation = 0;

        this.isDragging = false;
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.translateX = 0;
        this.translateY = 0;

    }

    // 🔹 Rodar imagem
    Rotate(deg) {
        this.rotation += deg;
    }

    // 🔹 Zoom in
    ZoomIn() {
        if (this.isDragging) return;
        this.zoom += 0.1;
    }

    // 🔹 Zoom out
    ZoomOut() {
        if (this.isDragging) return;
        if (this.zoom > 0.2) this.zoom -= 0.1;
    }

    StartDrag(event: MouseEvent) {
        if (this.zoom <= 1) return;
        this.isDragging = true;
        this.dragStartX = event.clientX - this.translateX;
        this.dragStartY = event.clientY - this.translateY;
    }

    OnDrag(event: MouseEvent) {
        if (!this.isDragging) return;
        this.translateX = event.clientX - this.dragStartX;
        this.translateY = event.clientY - this.dragStartY;
    }

    EndDrag() {
        this.isDragging = false;
    }

    OnWheel(event: WheelEvent) {

        event.preventDefault();

        if (this.isDragging) return;

        const delta = event.deltaY > 0 ? -0.1 : 0.1;
        this.zoom = Math.min(Math.max(this.zoom + delta, 1), 5);
    }


    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }


    private getFileType(fileName: string): 'pdf' | 'image' | 'unknown' {
        if (!fileName) return 'unknown';

        // 1️⃣  Obter a parte depois do último ponto
        const dotIndex = fileName.lastIndexOf('.');
        if (dotIndex === -1 || dotIndex === fileName.length - 1) {
            // não há extensão ou termina em ponto
            return 'unknown';
        }

        const ext = fileName.substring(dotIndex + 1).toLowerCase();

        // 2️⃣  Verificar PDF
        if (ext === 'pdf') return 'pdf';

        // 3️⃣  Lista de extensões de imagens suportadas
        const IMAGE_EXTS = new Set([
            'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tif', 'tiff', 'svg', 'heic', 'avif',
        ]);

        return IMAGE_EXTS.has(ext) ? 'image' : 'unknown';
    }

}
